import { gatewayUrl } from "@Constants/gatewayUrl";
import { filterConnectionTree } from "@Utils/tree/filterTree";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { useDebounce } from "../useDebounce";
export const useConnectionTree = ({ token, type })=>{
    const [isLoading, setIsLoading] = useState(true);
    const [isSearching, setIsSearching] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [attempt, setAttempt] = useState(0);
    const [items, setItems] = useState([]);
    const [filteredItems, setFilteredItems] = useState(items);
    const [selectedItem, setSelectedItem] = useState(null);
    const [id, setId] = useState(null);
    useEffect(()=>{
        const fetchAll = async (_token)=>{
            try {
                setIsLoading(true);
                setHasError(false);
                const header = {
                    headers: {
                        Authorization: `Bearer ${_token}`
                    }
                };
                const response = await axios.get(`${gatewayUrl}/plugins/word/tool/${type}`, header);
                setItems(response.data);
            } catch (error) {
                console.error("Error fetching data:", error);
                setHasError(true);
            } finally{
                setIsLoading(false);
            }
        };
        if (token) fetchAll(token);
    }, [
        token,
        attempt
    ]);
    const retry = useCallback(()=>setAttempt((count)=>count + 1), []);
    const [expandedItems, setExpandedItems] = useState([]);
    const onExpandedItemsChange = useCallback((itemIds)=>{
        setExpandedItems(itemIds);
    }, []);
    const [search, setSearch] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    useDebounce(()=>{
        setDebouncedSearch(search);
        setIsSearching(false);
    }, [
        search
    ], 300);
    const onSearch = useCallback((value)=>{
        setIsSearching(true);
        setSearch(value);
    }, []);
    useEffect(()=>{
        const filtered = filterConnectionTree(items, debouncedSearch, setExpandedItems, true);
        setFilteredItems(filtered);
    }, [
        items,
        debouncedSearch
    ]);
    const onSelectedItemsChange = useCallback((itemId, item)=>{
        setSelectedItem(itemId);
        setId(item.id);
    }, []);
    return {
        items: filteredItems,
        selectedItem,
        selectedId: id,
        expandedItems,
        search,
        showNoItemsMessage: !isLoading && !hasError && !filteredItems.length && !debouncedSearch,
        isLoading,
        hasError,
        retry,
        isSearching,
        onSearch,
        onExpandedItemsChange,
        onSelectedItemsChange
    };
};
